import React from "react";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { DownloadDocument } from "../Actions/CommonAPI";
import Moment from "moment";

class ReportCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      currentPage:1,
    };
  }

  render() {
    const { ReportList, pageSize , ReportCountList} = this.props;
    return (
      <div className="">
        {this.renderCardData()}
        {ReportList?.reports?.length !==0 ? (
          <> 
            <div className="col-lg-12 mb-4">
              <div className=" col-xl-11 col-lg-11 col-md-11 col-sm-10 col-9">
                <Paginator
                  first={this.state.first}
                  rows={pageSize}
                  totalRecords={ReportList.count ? ReportList.count : 0}
                  onPageChange={(e) => this.onPaginatorChange(e)}
                ></Paginator>
                </div>
              <div className="search-btn-col col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 pr-0" style={{ textAlign: "end",float:"right",marginTop:"-28px" }}>
                <span>
                  <span className="italicFont">{((this.state.currentPage-1) *10+1) + "-"+ (((ReportList?.count % 10) === 0)||(Math.ceil(ReportList?.count/10) !==this.state.currentPage) ?((this.state.currentPage-1)*10+10):((ReportList?.count % 10)+(this.state.currentPage-1)*10) ) }</span>{" "}
                  <span className="italicFont">{" "}of{" "}</span>{" "}
                  <strong>{ReportList?.reports ? ReportList?.count : 0}</strong>
                </span>
              </div>
              </div>
            
          </>
        ) : 
         ( ReportList.reports.length ===0 ?
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                No Reports to Display
              </h6>
            </div>
          </div>
          :<></>
        )} 
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
      currentPage:event.page+1,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { ReportList, downloadAttachment, ReportCountList } = this.props;
    return ReportList["reports"] && ReportList["reports"].length
      ? ReportList["reports"].map((item, index) => {
          return (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              {item.isHazardous ? (
                <div className="arrow-right-red"></div>
              ) : (
                <div className="arrow-right-green"></div>
              )}
              <div className="resource-list-auth-date p-3">
                <div className="row">
                  <div className="col-sm-4 mb-2">
                    <span>
                      <strong>PO Number : </strong>
                      <span className="italicFont ">{item.ponumber}</span>
                    </span>
                  </div>
                  <div className="col-sm-4">
                    <span>
                      <strong>Date PO released : </strong>
                      <span className="italicFont ">
                        {Moment(new Date(Date.parse(item.podate))).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </span>
                  </div>
                  <div className="col-sm-4">
                    <span>
                      <strong>Req Number : </strong>
                      <span className="italicFont "> {item.reqNumber}</span>
                    </span>
                  </div>
                  <div className="col-sm-4 ">
                    <span>
                      <strong>Maker Name : </strong>
                      <span className="italicFont "> {item.makerName}</span>
                    </span>
                  </div>
                  <div className="col-sm-4">
                    {/* <span><strong>MD Ref Number : </strong><span className="italicFont ">  {item.mdrefNumber}</span></span> */}
                    <span>
                      <strong>MD Ref : </strong>
                      <i aria-hidden="true"></i>{" "}
                      <span className="italicFont">{item.mdrefNumber}</span>
                      {item.mdocAttachmentName ? (
                        <i
                          class="fa fa-download click ml-1"
                          onClick={() =>
                            downloadAttachment(
                              item.mdocAttachmentName,
                              item.mdocAttachmentGuid
                            )
                          }
                        ></i>
                      ) : null}
                    </span>
                  </div>
                  <div className="col-sm-4">
                    {/* <span><strong>SD Ref Number : </strong><span className="italicFont ">  {item.sdrefNumber}</span></span> */}
                    <span>
                      <strong>SD Ref : </strong>
                      <i aria-hidden="true"></i>{" "}
                      <span className="italicFont">{item.sdrefNumber}</span>
                      {item.sdocAttachmentName ? (
                        <i
                          class="fa fa-download click ml-1"
                          onClick={() =>
                            downloadAttachment(
                              item.sdocAttachmentName,
                              item.sdocAttachmentGuid
                            )
                          }
                        ></i>
                      ) : null}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : "";
  };
}
export default ReportCard;
